export default "__VITE_ASSET__eyBMFovp__"